(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ng-testimonial-videos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ng-testimonial-videos'))customElements.define('ng-testimonial-videos',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelectorAll('.ngtv-card').forEach(card=>{const video=card.querySelector('video'),button=card.querySelector('[data-ngtv-play]');button.addEventListener('click',async()=>{if(!video.paused){video.pause();return;}try{await video.play();}catch(error){card.querySelector('[data-ngtv-error]').hidden=false;}});video.addEventListener('play',()=>{button.textContent=button.dataset.pause;document.querySelectorAll('ng-testimonial-videos video').forEach(other=>{if(other!==video&&!other.paused)other.pause();});});video.addEventListener('pause',()=>button.textContent=button.dataset.play);video.addEventListener('ended',()=>button.textContent=button.dataset.play);});}});
  } catch(e) { console.error(e); }
})();

})();
